import type { Session, User } from '@supabase/supabase-js'
import { supabase } from '~/lib/supabase'

export function isUserAnonymous(user: User | null | undefined): boolean {
  if (!user) {
    return false
  }

  if (typeof (user as unknown as { is_anonymous?: boolean }).is_anonymous === 'boolean') {
    return (user as unknown as { is_anonymous?: boolean }).is_anonymous === true
  }

  const identities = (user as unknown as { identities?: { provider?: string }[] }).identities

  if (Array.isArray(identities)) {
    return identities.every((identity) => identity.provider === 'anonymous')
  }

  return !user.email && !user.phone
}

export function isSessionAnonymous(session: Session | null | undefined): boolean {
  if (!session) {
    return false
  }

  return isUserAnonymous(session?.user)
}

export async function getOrCreateAnonymousUser() {
  const { data: sessionResult } = await supabase.auth.getUser()
  const user = sessionResult?.user

  if (user) {
    return user
  }

  const { error, data } = await supabase.auth.signInAnonymously()

  if (error) {
    console.error('Failed to create anonymous user', error)
    throw error
  }

  return data.user
}
